import {
  CountryType,
  StateType,
} from "../../PatientCare/Patientregistration/v1/type/RegistrationDataType";

export type SearchParamsType = {
  filter: {
    status: number;
    searchText: string;
    searchDate?: string; // ISO date string
  };
  sortOrder: string;
  sortField: string;
  pageNumber: number;
  pageSize: number;
  clinicId?: number;
};

export type SettingsTableDataType = {
  clinicId: number;
  emrLockTime: string;
  commonEntry: boolean;
  createdByDate: string;
  createdById: number;
  title: string;
  address1: string;
  address2: string;
  logo: string;
  letterHead: string;
  localPath: string;
  cloudOrLoc: number;
  remarks: string;
  place: string;
  status: number;
  stateId: number;
  stateName: string;
  countryId: number;
  countryName: string;
  licence: string;
  domainName: string;
  ministryId: number;
  ministryName: string;
  password: string;
  password2: string;
  emrLength: number | string;
  emrPrefix: string;
  username: string;
  currencyType: string;
  whatsapp: null;
  sms: null;
};

export type ClinicSettingData = {
  clinicId: number;
  emrLockTime: string;
  commonEntry: string;
  createdByDate: string;
  createdById: number;
  title: string;
  address1: string;
  address2: string;
  emrSetting: string;
  logo: string;
  letterHead: string;
  localPath: string;
  cloudOrLoc: number;
  remarks: string;
  place: string;
  status: number;
  stateId: number;
  stateName: string;
  countryId: number;
  countryName: string;
  licence: string;
  domainName: string;
  ministryId: number;
  ministryName: string;
  password: string;
  password2: string;
  emrLength: number;
  emrPrefix: string;
  username: string;
  currencyType: string;
  whatsapp: boolean;
  sms: boolean;
  letterPad: string;
  reviewLink?: string;
  zoomUrl?: string;
};

export type MinistriesType = {
  id: number;
  ministryName: string;
};

export type SettingsDataType = {
  clinicId: number;
  address1: string;
  address2: string | null;
  commonEntry: boolean;
  createdById: number;
  domainName: string;
  ip: string;
  isCloudOrLoc: number;
  localPath: string;
  logo: string;
  place: string;
  remarks: string;
  status: number;
  title: string;
  country: number;
  state: number;
  licence: string;
  ministry: number;
  password: string;
  username: string;
  followUpDays: number;
  emrSetting: string;
  usedCurrency: string | null;
  lockTime: number | null;
  letterHead: string;
  dhpoLicence: string;
  whatsapp: boolean;
  sms: boolean;
  emrPrefix: string | null;
  emrLength: number;
  reviewLink?: string;
  zoomUrl?: string;
};

export type SaveResponseType = {};

export type SettingsFormDataType = {
  title: string;
  address: string;
  address2: string | null;
  place: string;
  country: CountryType | null;
  state: StateType | null;
  ministry: MinistriesType | null;
  username: string;
  password: string;
  domain: string;
  licenceCode: string;
  renarks: string | null;
  clinicPrefix: string | null;
  emrLength: string | number;
  currencyType: string | null;
  emrlockTime: string | null;
  storage: number;
  status: number;
  fetchCommonEntries: boolean;
  logo: File | null;
  letterHead: File | null;
  letterPad: File | null;
  whatsapp: boolean;
  sms: boolean;
  reviewLink: string;
  zoomUrl: string;
};

export const initialFormData: SettingsFormDataType = {
  title: "",
  address: "",
  address2: null,
  place: "",
  country: null,
  state: null,
  ministry: null,
  username: "",
  password: "",
  domain: "",
  licenceCode: "",
  renarks: null,
  clinicPrefix: null,
  emrLength: "",
  currencyType: null,
  emrlockTime: null,
  storage: 1,
  status: 1,
  fetchCommonEntries: false,
  logo: null,
  letterHead: null,
  whatsapp: false,
  sms: false,
  letterPad: null,
  reviewLink: "",
  zoomUrl: "",
};
